import React from "react";
import { PonesiCoinIcon, Coins } from "./PonesiCoinIcon";

export const isCoinOrder = (o) => String(o?.payment_method || "").toUpperCase() === "PONESI_COINS";

/** Kitchen-facing marker for a legitimate loyalty redemption. The card never shows a bare 0 RSD:
 * it shows PONESI COINS + the exact number of coins spent. */
export function CoinPaymentBadge({ o, className = "" }) {
  if (!isCoinOrder(o)) return null;
  return (
    <span data-testid={`coin-payment-badge-${o?.order_number}`}
      className={`inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider rounded-full px-2 py-0.5 bg-amber-100 text-amber-800 shrink-0 ${className}`}>
      <PonesiCoinIcon size={12} />Ponesi Coins
    </span>
  );
}

/** Amount line replacement for coin-paid orders. */
export function CoinAmount({ o, size = 14, className = "" }) {
  if (!isCoinOrder(o)) return null;
  return <Coins value={o.coins_redeemed} size={size} className={className}
    testid={`coin-amount-${o?.order_number}`} />;
}
